import React, { useContext, useState, useMemo } from "react";
import { GlobalContext } from "globalContext";
import request from "services/http";
import { tap, finalize } from "rxjs/operators";
import { Form, Button, Icon } from "semantic-ui-react";
import { DateTime } from "luxon";
import InputMask from "react-input-mask";
import { toast } from "react-toastify";
import { useSubscription } from "utils";

export default function GerarForm({
    setRegistros,
    form,
    dispatch,
    tipos,
    periodos,
    operacoes,
    cortes
}) {
    const [globalState] = useContext(GlobalContext);
    const [isLoading, setLoading] = useState(false);

    function handleChange(event, props) {
        let name, value;
        if (!props) [name, value] = [event.target.name, event.target.value];
        else {
            name = props.name;
            value = props.value;
        }
        if (
            (name === "considerarCorte" && value === true) ||
            (form.considerarCorte === true && name === "empresa") ||
            (form.considerarCorte === true && name === "tipo")
        ) {
            const tp = name === "tipo" ? value : form.tipo;
            if (name === "empresa")
                dispatch({
                    type: "setForm",
                    payload: {
                        [name]: value,
                        dataIni: !!cortes.find(
                            x => x && x.empresa === value && x.tipo === tp
                        )
                            ? DateTime.fromFormat(
                                  cortes.find(
                                      x =>
                                          x &&
                                          x.empresa === value &&
                                          x.tipo === tp
                                  ).corte + "",
                                  "yyyyMMdd"
                              )
                                  .plus({ days: 1 })
                                  .toFormat("dd/MM/yyyy")
                            : ""
                    }
                });
            else
                dispatch({
                    type: "setForm",
                    payload: {
                        [name]: value,
                        dataIni: !!cortes.find(
                            x =>
                                x && x.empresa === form.empresa && x.tipo === tp
                        )
                            ? DateTime.fromFormat(
                                  cortes.find(
                                      x =>
                                          x &&
                                          x.empresa === form.empresa &&
                                          x.tipo === tp
                                  ).corte + "",
                                  "yyyyMMdd"
                              )
                                  .plus({ days: 1 })
                                  .toFormat("dd/MM/yyyy")
                            : ""
                    }
                });
        } else dispatch({ type: "setForm", payload: { [name]: value } });
    }

    function handleSubmit() {
        setLoading(true);
    }

    const submitForm$ = useMemo(
        () =>
            request({
                url: "/dre/pdd",
                method: "POST",
                body: form
            }).pipe(
                tap(({ response }) => {
                    if ("faturas" in response || "cheques" in response) {
                        if (
                            (response.faturas && !response.faturas.length) ||
                            (response.cheques && !response.cheques.length)
                        )
                            toast.info("Nenhum registro encontrado.");
                        setRegistros(
                            "faturas" in response
                                ? response.faturas
                                : response.cheques
                        );
                    }
                }),
                finalize(() => setLoading(false))
            ),
        [form, setRegistros]
    );

    useSubscription(submitForm$, isLoading);

    return (
        <Form size="mini" className="w-100" onSubmit={handleSubmit} noValidate>
            <div className="row">
                <div className="col">
                    <Form.Select
                        search
                        noResultsMessage="Nenhum resultado encontrado"
                        required
                        label="Empresa"
                        placeholder="Selecionar empresa"
                        name="empresa"
                        value={form.empresa}
                        onChange={handleChange}
                        options={
                            globalState.empresas
                                ? globalState.empresas
                                      .filter(
                                          x =>
                                              x.ativo === 1 &&
                                              x.tipo === "POSTO"
                                      )
                                      .map(x =>
                                          Object.assign(
                                              {},
                                              {
                                                  text:
                                                      x.codDpnet +
                                                      " - " +
                                                      x.nomeEmpresa,
                                                  value: x._id
                                              }
                                          )
                                      )
                                : []
                        }
                    />
                </div>
                <div className="col">
                    <Form.Select
                        required
                        label="Periodo"
                        placeholder="Selecione o trimestre"
                        name="periodo"
                        value={form.periodo}
                        onChange={handleChange}
                        options={
                            periodos
                                ? periodos.map(x =>
                                      Object.assign(
                                          {},
                                          { text: x.descricao, value: x.id }
                                      )
                                  )
                                : []
                        }
                    />
                </div>
            </div>
            <div className="row pt-3">
                <div className="col">
                    <Form.Select
                        required
                        label="Tipo"
                        placeholder="Selecionar tipo"
                        name="tipo"
                        value={form.tipo}
                        onChange={handleChange}
                        options={
                            tipos
                                ? tipos.map(x =>
                                      Object.assign(
                                          {},
                                          {
                                              text: x.descricao,
                                              value: x.tipo_entrada
                                          }
                                      )
                                  )
                                : []
                        }
                    />
                </div>
                <div className="col">
                    <Form.Select
                        required
                        label="Operação"
                        placeholder="Escolha a operação"
                        name="operacao"
                        value={form.operacao}
                        onChange={handleChange}
                        options={
                            operacoes
                                ? operacoes.map(x =>
                                      Object.assign(
                                          {},
                                          { text: x.descricao, value: x.id }
                                      )
                                  )
                                : []
                        }
                    />
                </div>
            </div>
            {form.operacao === 1 && (
                <div className="row pt-3">
                    <div className="col">
                        <InputMask
                            mask="99/99/9999"
                            name="dataIni"
                            disabled={
                                form.considerarCorte &&
                                !!cortes.find(
                                    x =>
                                        x &&
                                        x.empresa === form.empresa &&
                                        x.tipo === form.tipo
                                ) === true
                            }
                            value={form.dataIni}
                            onChange={handleChange}
                        >
                            {inputProps => (
                                <Form.Input
                                    {...inputProps}
                                    disabled={
                                        form.considerarCorte &&
                                        !!cortes.find(
                                            x =>
                                                x &&
                                                x.empresa === form.empresa &&
                                                x.tipo === form.tipo
                                        ) === true
                                    }
                                    required={form.operacao === 1}
                                    label="Data Inicial"
                                    placeholder="Informar data inicial"
                                />
                            )}
                        </InputMask>
                    </div>
                    <div className="col">
                        <InputMask
                            mask="99/99/9999"
                            name="dataFim"
                            value={form.dataFim}
                            onChange={handleChange}
                        >
                            {inputProps => (
                                <Form.Input
                                    {...inputProps}
                                    required={form.operacao === 1}
                                    label="Data Final"
                                    placeholder="Informar data final"
                                />
                            )}
                        </InputMask>
                    </div>
                </div>
            )}
            <div className="row pt-3">
                <div className="col-12">
                    <Form.Checkbox
                        label="Desconsiderar empresas do grupo"
                        name="desconsiderarGrupo"
                        checked={form.desconsiderarGrupo}
                        onChange={(evt, { name, checked }) =>
                            handleChange(evt, { name, value: checked })
                        }
                    />
                </div>
                {form.operacao === 1 && (
                    <div className="col-12">
                        <Form.Checkbox
                            label="Considerar data de corte"
                            name="considerarCorte"
                            checked={form.considerarCorte}
                            onChange={(evt, { name, checked }) =>
                                handleChange(evt, { name, value: checked })
                            }
                        />
                    </div>
                )}
            </div>
            <div className="row pt-4 text-center">
                <div className="col">
                    <Button
                        className="w-25 btn-primary"
                        size="tiny"
                        animated="fade"
                        primary
                        loading={isLoading}
                        disabled={isLoading}
                    >
                        <Button.Content visible>Buscar</Button.Content>
                        <Button.Content hidden>
                            <Icon name="search" />
                        </Button.Content>
                    </Button>
                </div>
            </div>
        </Form>
    );
}
